// @flow

import React from 'react';
import styles from './styles.module.scss';
import Check from './Check';

export type Value = string | number;

export type Option = {
  label: string,
  value: Value,
};

type Props = {
  // onToggle?: (option: ToggleOption) => void,
  options: Option[],
  selectedOptions: any,
  setSelectedOptions?: () => void,
  disabledPositions?: any,
  limitIsHU?: boolean,
  isFreeUser?: boolean,
  avoidDelimiters?: boolean,
  timerIsActive?: boolean,
  forPreflop?: boolean,
};

const Multicheckbox = ({
  options,
  selectedOptions,
  setSelectedOptions,
  disabledPositions,
  limitIsHU,
  isFreeUser,
  avoidDelimiters,
  timerIsActive,
  forPreflop,
}: Props) => {
  const previousIsDel = (idx) => {
    if (idx === 0) {
      return true;
    }

    if (options[idx - 1].value === 'del') {
      return true;
    }

    return false;
  };

  const nextIsDel = (idx) => {
    if (idx === options.length - 1) {
      return true;
    }

    if (options[idx + 1].value === 'del') {
      return true;
    }

    return false;
  };

  const checkFree = (value) => {
    if (timerIsActive) return true;
    if (!isFreeUser) return false;
    if (!['randomRfi', 'ep', 'mp', 'co', 'bu', 'sb', 'random'].includes(value)) return true;
    return false;
  };

  return (
    <div className={`${styles.wrapper} ${forPreflop ? styles.preflop : ''}`}>
      {options && options.map((option, idx) => {
        const disabled = disabledPositions?.includes(option.value);
        if (option.value === 'del') {
          return <div className={`${(limitIsHU || avoidDelimiters) ? '' : styles.delimeter}`} />;
        }
        return (
          <Check
            label={option.label}
            value={option.value}
            key={option.value}
            onCheck={setSelectedOptions}
            checked={selectedOptions?.includes(option.value)}
            disabled={disabled}
            previousIsDel={previousIsDel(idx)}
            nextIsDel={nextIsDel(idx)}
            disabledByFree={checkFree(option.value)}
          />
        );
      })}
    </div>
  );
};
export default Multicheckbox;
